import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import Langs from "../../../app/lang/langs";
import { useDispatch } from "react-redux";
import { InputText } from "primereact/inputtext";
import { DynamicButton } from "../../../components/buttons/DynamicButton";
import { Col, Row } from "react-bootstrap";
import { addEditPoste, getPostesSettings } from "../settingsSlice";
import { showErrorToast, showSuccessToast } from "../../../app/utils/helpers";



export default function AddPosteModal(props) {

    const dispatch = useDispatch()
    const [name, setName] = useState('');
    const [flag, setFlag] = useState(false)
    const handleClose = () => {
        props.setVisible(false);
        setName('')
        setFlag(false)
    }
    const handleAdd = () => {
        if (name.trim() == '') {
            setFlag(true)
        } else {
            dispatch(addEditPoste({ name: name })).then((actionResponse) => {
                if (addEditPoste.fulfilled.match(actionResponse)) {
                    if (actionResponse.payload.responseData && actionResponse.payload.responseData.status) {
                        dispatch(getPostesSettings());
                        showSuccessToast(actionResponse.payload.responseData.message)
                    }
                }
                if (actionResponse.payload.responseData.status === 0) {
                    showErrorToast(actionResponse.payload.responseData.message);
                }
            })
            handleClose()
        }
    }
    const body = () => {
        return (
            <Row className="p-2">
                <Col lg={9}>
                    <InputText invalid={flag} style={{ width: "80%" }} value={name} onChange={(e) => setName(e.target.value)} />
                </Col>
                <Col lg={3}>
                    <DynamicButton
                        onClick={() => handleAdd()}
                        className=''
                        title={<Langs str="ADD" />}
                        active={true}
                        color="green"
                    />
                </Col>
            </Row>
        )
    }
    return (
        <Dialog
            visible={props.visible}
            style={{ width: '50rem' }}
            onHide={() => { if (!props.visible) return; handleClose() }}
            position="center"
            draggable={false}
            header={<Langs str="ADD_POSTE" />}
        >
            {body()}
        </Dialog>
    )
}